import Process from 'actions/process';
import { DEFAULT_KEY, generateCacheTTL, checkCacheValid } from 'redux-cache';

const defaultState = {
  [DEFAULT_KEY]: null,
  loading: false,
  entities: {
    allIds: [],
    byId: {},
  },
};

export default Process.createReducer((state = defaultState, action) => {
  if (action.type == 'CLEAR_PROCESS_FOR_PROJECT') {
    const removedIds = [];
    const newEntities = { ...state.entities.byId };

    // find all of the Ids that belong to this project, and were not just added by updating the project
    state.entities.allIds
      .map((id) => state.entities.byId[id])
      .forEach((process) => {
        // check if process belongs to project
        if (process.project_id === action.payload.projectId) {
          // check if it was not just added
          if (!action.payload.process.includes(process.id)) {
            // store ID
            removedIds.push(process.id);
            // remove from byId
            delete newEntities[process.id];
          }
        }
      });
    // create newIds
    const newIds = state.entities.allIds.filter(
      (id) => !removedIds.includes(parseInt(id))
    );
    // build new state
    return {
      ...state,
      entities: {
        allIds: newIds,
        byId: newEntities,
      },
    };
  }

  return state;
});
